import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { SelectOption } from 'ui';

dayjs.extend(utc);

export interface FinancialYearRange {
  date_from: string;
  date_to: string;
}

export const getFinancialYearRangeByYear = (year: number): FinancialYearRange => {
  const safeYear = Number.isFinite(year) ? year : dayjs.utc().year();
  const start = dayjs.utc(`${safeYear - 1}-07-01`).startOf('day');
  const end = dayjs.utc(`${safeYear}-06-30`).endOf('day');

  return {
    date_from: start.toISOString(),
    date_to: end.toISOString(),
  };
};

export const getTaxReportYearOptions = (
  count = 11,
  fromYear = dayjs.utc().year(),
): SelectOption<number>[] => {
  return Array.from({ length: count }, (_, idx) => fromYear - idx).map(year => ({
    value: year,
    label: String(year),
  }));
};
